/**
 * Created by Bazu-05 on 27.05.2020.
 */

export const alert = {
        state: {
            alerts: [],
        },
        getters: {
            alerts: state => state.alerts
    },
    mutations: {
        ADD_ALERT(state, payload) {
            state.alerts.push(payload)
        },
        REMOVE_ALERT(state, payload) {
            const alert = state.alerts.findIndex(alert => alert.id === payload)
            state.alerts.splice(alert, 1)
        },
    },
    actions: {
        //type = error, info, success, warning
        ADD_ALERT({commit, state, dispatch}, {type, text}){
            const createId = () => Date.now().toString(36) + Math.random().toString(36).substr(2);
            const id = createId();

            setTimeout(() => {
                const alert = state.alerts.findIndex(alert => alert.id == id)
            if(alert !== -1) {
                dispatch('REMOVE_ALERT', id);
            }
        }, 5300);

            commit('ADD_ALERT', {
                id: id,
                type: type,
                text: text,
            })


        },
        REMOVE_ALERT({commit}, id) {
            commit('REMOVE_ALERT', id)
        },
        errorsHander({dispatch}, response) {
            if(response.status === 422 && response.data.error) {
                let errors = response.data.errors;
                Object.keys(errors).forEach(key => {
                    dispatch('ADD_ALERT', {type: "error", text: errors[key][0]})
                })
            } else {
                dispatch('ADD_ALERT', {type: "error", text: response.data.message})
            }

        },
    }
}